import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import Notifications from 'react-notification-system-redux'
import validator from 'validator'

import { url, handleCommonEditActions, validationMessage, getPrerequisitesArray } from '../../../common/helpers'
import * as formatters from '../../../common/formatters'
import { Form, InputField, SelectField, CheckboxField, SubmitButton } from '../../../common/form'
import { createGetCountryByIDSelector, createGetCurrentCountryStatusSelector } from '../selectors'
import * as countriesActionCreators from '../actionCreators'
import { LoadingOverlay } from '../../../common/loading_overlay'
import { preparePrerequisitesFetchStatusSelectors } from '../../../common/prerequisites/selectors'
import { preparePrerequisitesActionCreators } from '../../../common/prerequisites/actionCreators'
import PermissionsCheck from '../../auth/components/PermissionsCheck'

import { PERMS } from '../permissions'

const componentIdentifier = 'countries_edit'
const prerequisites = ['currencies_with_rates']

class CountriesEdit extends Component {
    defaultValues = {
        toll_per_km: 0,
        toll_per_day: 0,
    }

    validationRules = {
        iso_code: value => {
            if (validator.isEmpty(String(value))) {
                return validationMessage('isEmpty')
            }
            return !validator.isLength(String(value), { min: 3, max: 3 }) && validationMessage('isLength', { min: 3, max: 3 })
        },
        iso_code_2: value => {
            if (validator.isEmpty(String(value))) {
                return validationMessage('isEmpty')
            }
            return !validator.isLength(String(value), { min: 2, max: 2 }) && validationMessage('isLength', { min: 2, max: 2 })
        },
        name: value => validator.isEmpty(String(value)) && validationMessage('isEmpty'),
        currency_id: value => !value && validationMessage('isEmpty'),
        toll_per_km: value => !validator.isFloat(String(value)) && validationMessage('isFloat'),
        toll_per_day: value => !validator.isFloat(String(value)) && validationMessage('isFloat'),
        minimum_hour_wage: value => !validator.isFloat(String(value)) && validationMessage('isFloat'),
    }

    state = {
        values: this.defaultValues,
    }

    setValues = (values, callback) => {
        this.setState(
            {
                values,
            },
            callback
        )
    }

    handleChangeValues = values => {
        this.setValues(values)
    }

    handleSubmit = values => {
        this.setValues(values, () => {
            this.handleSave()
        })
    }

    handleSave = () => {
        this.props.actions.saveCountry(this.state.values)
    }

    componentDidMount() {
        this.props.match.params.countryID && this.props.actions.fetchCountry(this.props.match.params.countryID)
        this.props.actions.fetchPrerequisites()
    }

    componentWillReceiveProps(nextProps) {
        handleCommonEditActions(this.props, nextProps, () => {
            this.props.redirect(url(this.props.match, 'countries'))
        })

        if (JSON.stringify(nextProps.country) !== JSON.stringify(this.props.country) || (nextProps.country && !this.state.values.id)) {
            this.setValues(nextProps.country.toJS())
        }
    }

    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.countries.heading' }))

        return (
            <PermissionsCheck hasAny={Object.values(PERMS)} noPermissionsPage>
                <div className="page-inner">
                    <div id="main-wrapper">
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4">
                                <div className="panel panel-white">
                                    <div className="panel-body panel-padding">
                                        <div className="panel-head">
                                            <h4>
                                                <FormattedMessage id="modules.countries.heading" /> -{' '}
                                                {this.props.country ? (
                                                    <FormattedMessage id="fields.itemEdit" />
                                                ) : (
                                                    <FormattedMessage id="fields.itemCreate" />
                                                )}
                                            </h4>
                                        </div>
                                        <LoadingOverlay active={this.props.prerequisites.status.get('fetching') || this.props.status.get('fetching')}>
                                            <PermissionsCheck hasAny={Object.values(PERMS)}>
                                                <Form
                                                    values={this.state.values}
                                                    validationRules={this.validationRules}
                                                    onChange={this.handleChangeValues}
                                                    onSubmit={this.handleSubmit}
                                                    isEdit={Boolean(this.props.country)}
                                                >
                                                    <InputField
                                                        id="iso_code"
                                                        label={this.props.intl.formatMessage({ id: 'fields.isoCode3' })}
                                                        className="wp-20"
                                                    />
                                                    <InputField
                                                        id="iso_code_2"
                                                        label={this.props.intl.formatMessage({ id: 'fields.isoCode2' })}
                                                        className="wp-20"
                                                    />
                                                    <InputField
                                                        id="name"
                                                        label={this.props.intl.formatMessage({ id: 'fields.name' })}
                                                        className="wp-50"
                                                    />
                                                    <SelectField
                                                        id="currency_id"
                                                        label={this.props.intl.formatMessage({ id: 'fields.currency' })}
                                                        values={getPrerequisitesArray(
                                                            this.props.prerequisites.values.get('currencies_with_rates'),
                                                            'id',
                                                            'iso_code'
                                                        )}
                                                        className="wp-50"
                                                    />
                                                    <InputField
                                                        id="toll_per_km"
                                                        label={this.props.intl.formatMessage({ id: 'fields.tollPerKm' })}
                                                        className="wp-20"
                                                    />
                                                    <InputField
                                                        id="toll_per_day"
                                                        label={this.props.intl.formatMessage({ id: 'fields.tollPerDay' })}
                                                        className="wp-20"
                                                    />
                                                    <InputField
                                                        id="minimum_hour_wage"
                                                        label={this.props.intl.formatMessage({ id: 'fields.minimumHourWageInSelectedCurrency' })}
                                                        className="wp-20"
                                                    />
                                                    <CheckboxField id="is_in_eu" label={this.props.intl.formatMessage({ id: 'fields.inEU' })} />

                                                    <div className="btns-form">
                                                        <Link to={url(this.props.match, 'countries')} className="btn btn-addon btn-default">
                                                            <i className="far fa-chevron-left" /> <FormattedMessage id="buttons.back" />
                                                        </Link>
                                                        <SubmitButton
                                                            perms={Object.values(PERMS)}
                                                            isEdit={Boolean(this.props.country)}
                                                            className="btn-addon pull-right"
                                                        />
                                                    </div>
                                                </Form>
                                            </PermissionsCheck>
                                        </LoadingOverlay>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PermissionsCheck>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        country: createGetCountryByIDSelector(ownProps.match.params.countryID)(state),
        status: createGetCurrentCountryStatusSelector()(state),
        prerequisites: preparePrerequisitesFetchStatusSelectors(componentIdentifier, prerequisites, state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...countriesActionCreators,
                    ...preparePrerequisitesActionCreators(componentIdentifier, prerequisites),
                },
                dispatch
            ),
        },
        redirect: toURL => dispatch(push(toURL)),
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(CountriesEdit)
)
